import React from 'react'
export const weeth_circle_color = {
  path: (
    <>
      <path
        d="M16.0035 23.6733C16.0035 23.8227 15.8456 23.9194 15.7125 23.8514L9.73942 20.8017C9.5927 20.7268 9.5944 20.5165 9.74231 20.444L15.7154 17.5146C15.8483 17.4494 16.0035 17.5461 16.0035 17.6941V23.6733Z"
        fill="url(#paint0_linear_14360_3186)"
      />
      <path
        d="M16.0034 17.6951C16.0034 17.5469 16.159 17.4502 16.2919 17.5158L22.2651 20.4632C22.4128 20.5361 22.414 20.7464 22.2671 20.8209L16.2939 23.8526C16.1609 23.9202 16.0034 23.8235 16.0034 23.6743V17.6951Z"
        fill="url(#paint1_linear_14360_3186)"
      />
      <path
        d="M19.7422 15.5514C19.8394 15.5042 19.9566 15.5427 20.0067 15.6385L22.3385 20.0895C22.4283 20.261 22.2464 20.4473 22.0728 20.3616L16.3698 17.5475C16.2206 17.4738 16.2213 17.2609 16.3709 17.1882L19.7422 15.5514Z"
        fill="url(#paint2_linear_14360_3186)"
      />
      <path
        d="M12.0062 15.6253C12.0567 15.5296 12.1742 15.4914 12.2714 15.5391L15.6374 17.1934C15.7866 17.2667 15.7864 17.4795 15.637 17.5526L9.92742 20.3442C9.7536 20.4292 9.57242 20.2424 9.66265 20.0712L12.0062 15.6253Z"
        fill="url(#paint3_linear_14360_3186)"
      />
      <path
        d="M16.0061 17.3732C16.0047 17.3732 16.0036 17.3721 16.0036 17.3707V8.82018C16.0036 8.61113 15.7233 8.54223 15.6263 8.72746L12.1989 15.2778C12.1467 15.3775 12.1871 15.5007 12.2882 15.5502L16.0072 17.3685C16.0095 17.3696 16.0087 17.3732 16.0061 17.3732Z"
        fill="url(#paint4_linear_14360_3186)"
      />
      <path
        d="M16.291 17.2332C16.1582 17.2979 16.0034 17.2012 16.0034 17.0534V8.81848C16.0034 8.60953 16.2835 8.54054 16.3805 8.72557L19.821 15.2842C19.8734 15.3841 19.8329 15.5075 19.7315 15.5569L16.291 17.2332Z"
        fill="url(#paint5_linear_14360_3186)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3333 3C23.696 3 29.6667 8.97067 29.6667 16.3333C29.6667 23.696 23.696 29.6667 16.3333 29.6667C8.97067 29.6667 3 23.696 3 16.3333C3 8.97067 8.97067 3 16.3333 3Z"
        fill="url(#paint6_linear_14360_3186)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3334 4.54702C9.82501 4.54702 4.54702 9.82501 4.54702 16.3334C4.54702 22.8419 9.82501 28.1199 16.3334 28.1199C22.8419 28.1199 28.1199 22.8419 28.1199 16.3334C28.1199 9.82501 22.8419 4.54702 16.3334 4.54702ZM3.94702 16.3334C3.94702 9.49364 9.49364 3.94702 16.3334 3.94702C23.1733 3.94702 28.7199 9.49364 28.7199 16.3334C28.7199 23.1733 23.1733 28.7199 16.3334 28.7199C9.49364 28.7199 3.94702 23.1733 3.94702 16.3334Z"
        fill="#040B6C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7848 7.05469L16.0464 6.8716C16.2185 6.75113 16.4476 6.75113 16.6198 6.8716L21.4238 10.2337L21.4308 10.2387L21.4663 10.2635C21.5733 10.3384 21.637 10.4607 21.637 10.5912V10.6319L21.6371 10.6433V15.4196C21.6371 15.609 21.5301 15.7821 21.3607 15.8668L16.5567 18.2688C16.4159 18.3392 16.2502 18.3392 16.1095 18.2688L11.3054 15.8668C11.1361 15.7821 11.0291 15.609 11.0291 15.4196V15.176V10.6433V10.5912C11.0291 10.4607 11.0928 10.3384 11.1997 10.2635L11.2419 10.234L11.2424 10.2337L11.4765 10.0698L15.4008 7.32344L15.7845 7.05492L15.7848 7.05469ZM16.333 7.6289L20.8922 15.3788C20.9002 15.3924 20.9088 15.4053 20.9177 15.4175L16.3331 17.7098L11.7483 15.4174C11.7573 15.4053 11.7658 15.3924 11.7738 15.3788L16.333 7.6289ZM11.6291 14.4416V10.9623L13.3259 11.5573L11.6291 14.4416ZM11.9802 10.4496L15.3646 8.08106L13.618 11.0239L11.9802 10.4496ZM21.037 14.4416L19.3402 11.5573L21.037 10.9623V14.4416ZM20.6858 10.4496L17.3014 8.08106L19.048 11.0239L20.6858 10.4496ZM20.5612 22.4041L17.2093 24.0801L18.7403 21.7836L20.5612 22.4041ZM21.0371 21.936C21.0193 21.9276 21.0006 21.92 20.9811 21.9133L19.0846 21.2671L21.0371 18.3384V21.936ZM11.3054 22.6752L11.3 22.6724L11.2503 22.6475C11.1147 22.5798 11.0291 22.4413 11.0291 22.2898L11.0291 22.2371L11.0291 22.228V17.6674C11.0291 17.298 11.4158 17.0561 11.7479 17.2178L16.3331 19.4504L20.9182 17.2178C21.2504 17.0561 21.6371 17.298 21.6371 17.6674V17.6778L21.6371 22.228V22.2898C21.6371 22.4413 21.5515 22.5798 21.416 22.6475L21.3607 22.6752L21.0435 22.8338L17.1356 24.7877L17.1347 24.7882L16.8041 24.9535L16.5567 25.0772C16.4159 25.1476 16.2502 25.1476 16.1095 25.0772L11.3054 22.6752ZM16.1142 20.0111L12.1924 18.1016L14.3164 21.2876C14.3472 21.3154 14.375 21.3474 14.3987 21.3833L16.1713 24.0648C16.1817 24.0805 16.1911 24.0963 16.1995 24.1122L16.3331 24.3127L16.4668 24.1122C16.4752 24.0963 16.4845 24.0805 16.4949 24.0648L18.2676 21.3833C18.2913 21.3474 18.319 21.3154 18.3499 21.2876L20.4739 18.1015L16.552 20.0111C16.4138 20.0784 16.2524 20.0784 16.1142 20.0111ZM12.105 22.4041L15.4569 24.0801L13.926 21.7836L12.105 22.4041ZM13.5816 21.2671L11.6851 21.9133C11.6656 21.92 11.647 21.9276 11.6291 21.936L11.6291 18.3384L13.5816 21.2671Z"
        fill="#040B6C"
      />
      <defs>
        <linearGradient
          id="paint0_linear_14360_3186"
          x1="10.8168"
          y1="18.3933"
          x2="17.5835"
          y2="21.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8175A5" />
          <stop offset="1" stopColor="#63577F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_14360_3186"
          x1="15.9501"
          y1="24.6601"
          x2="20.8701"
          y2="17.4534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#655981" />
          <stop offset="0.2" stopColor="#73628C" />
          <stop offset="1" stopColor="#B3A5DA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_14360_3186"
          x1="18.8701"
          y1="18.9"
          x2="24.0367"
          y2="13.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFA0D8" />
          <stop offset="1" stopColor="#CEC6E6" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_14360_3186"
          x1="12.7235"
          y1="18.64"
          x2="13.4502"
          y2="16.4533"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#887BAE" />
          <stop offset="1" stopColor="#796D9B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_14360_3186"
          x1="16.8969"
          y1="12.6866"
          x2="13.4636"
          y2="12.6866"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFA0D8" />
          <stop offset="1" stopColor="#887BAE" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_14360_3186"
          x1="17.1168"
          y1="13.7667"
          x2="19.5434"
          y2="16.0667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFA0D8" />
          <stop offset="1" stopColor="#CEC6E6" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_14360_3186"
          x1="3.69542"
          y1="24.1021"
          x2="28.185"
          y2="7.61473"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0557581" stopColor="#59BDF5" />
          <stop offset="0.430955" stopColor="#6969DF" />
          <stop offset="0.95102" stopColor="#AA68F2" />
        </linearGradient>
      </defs>
    </>
  ),
  viewBox: '0 0 32 32',
}
